import { LinkText, Link } from '../Link';
import { QuickLinkItem } from './QuickLinkItem';

export interface IQuickLinkExternalProps {
	title: string;
	url: string;
}

export function QuickLinkExternal({ title, url }: IQuickLinkExternalProps) {
	return (
		<QuickLinkItem>
			<Link href={url} target="_blank">
				<LinkText>{title}</LinkText>
			</Link>
		</QuickLinkItem>
	);
}
